// extracted by mini-css-extract-plugin
export default {"spinnerLogo":"styles_spinnerLogo__QlpDc"};